import { FC } from 'react';
import Dialog from 'src/components/Dialog';
import Grid, { GridItem } from 'src/components/Grid';
import TableSimple from 'src/components/TableSimple';
import TextField from 'src/components/TextField';
import { CustomRenderType, TableRowType } from 'src/types/table';
import { orderDataKeys, productTableColumns, xchangeKeys } from './constants';
import { styled } from '@mui/system';
import translate from '@translate';
import getStatusColor from '../../utils/getStatusColor';
import { colors } from '../../themes/default';
import { getOrderProductDisplaySku } from 'src/utils/orderProductDisplay';

export interface OrderDetailProps {
    order: TableRowType;
    onClose?: () => void;
}

const InfoBlock = styled('div')({
    '& .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2': {
        paddingTop: '16px',
    },
    '& .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-4': {
        paddingTop: '0px',

        '& .MuiFormHelperText-root.Mui-disabled.MuiFormHelperText-sizeMedium.MuiFormHelperText-contained': {
            display: 'none',
        },

        '& input.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled.MuiInputBase-inputAdornedEnd': {
            padding: '5px 10px',
        },

        '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd.MuiInputAdornment-outlined.MuiInputAdornment-sizeMedium': {
            display: 'none',
        },
    },
});

const OrderDetail: FC<OrderDetailProps> = (props) => {
    const rows: TableRowType[] = (props.order.ORDER_PRODUCTS || []).map((product: TableRowType) => product);

    const customRender: CustomRenderType = (column, row) => {
        if (column.key === 'SKU') {
            return getOrderProductDisplaySku(row);
        }

        if (column.key === 'COUNT' && row.COUNT < 0) {
            return (
                <span style={{ color: colors.alert_O }}>
                    {row.COUNT}
                </span>
            );
        }

        if (column.key === 'COUNT' && (row.COUNT === 0 || !Number.isInteger(row.COUNT))) {
            return (
                <span style={{ color: colors.alert_O }}>
                    {row.COUNT}
                </span>
            );
        }

        if (column.key === 'PRODUCT_PRICE' && (row.PRODUCT_PRICE === 0 || !Number.isInteger(row.PRODUCT_PRICE))) {
            return (
                <span style={{ color: colors.alert_O }}>
                    {row.PRODUCT_PRICE}
                </span>
            );
        }

        return '';
    };

    return (
        <Dialog onClose={props.onClose} maxWidth="lg" title={translate('ordersImport.detailOrder')}>
            <InfoBlock>
                <Grid>
                    {orderDataKeys.map((key) => {
                        return (
                            <GridItem cols={4} key={key}>
                                <TextField
                                    label={xchangeKeys[key] || key}
                                    value={props.order[key]}
                                    disabled
                                    fullWidth
                                />
                            </GridItem>
                        );
                    })}
                </Grid>
                <TableSimple
                    rowIdKey="PRODUCT_ID"
                    rows={rows}
                    columsLabelPrefix=""
                    allColumns={productTableColumns}
                    initSort={{ column: 'PRODUCT_ID', direction: 'DESC' }}
                    disableFilter
                    customRender={customRender}
                    sumCols={{ COUNT: true }}
                    showInModal
                />
            </InfoBlock>
        </Dialog>
    );
};
export default OrderDetail;
